import {Button} from 'shells/button/button';
import dialogStyles from 'shells/dialog/dialog.module.css';
import {Popover} from 'shells/popover/popover';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    anchorElementId: string;
    question: string;
}

export function NoPhoneNumbersDialog(props: Props) {
    if (!props.isOpen) {
        return null;
    }

    return (
        <Popover
            anchor={null}
            anchorElementId={props.anchorElementId}
            isDialog={true}
            bodyColor='dark'
            onBlur={props.onClose}
            location='bottom'
        >
            <div onClick={(e) => e.stopPropagation()}>
                <div className={dialogStyles.question}>{props.question}</div>
                <div className={dialogStyles.buttons}>
                    <div className={dialogStyles['right-buttons']}>
                        <Button variant='secondary' onClick={props.onClose}>
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        </Popover>
    );
}
